import { ComponentState } from '../../../types/ComponentStates.types';
import { LabeledComponent, LabeledComponentProperties, LabeledComponentProps } from '../inputs/LabeledComponent';
import Timepicker, { TimepickerProps } from './Timepicker';

interface LabeledProps extends Omit<LabeledComponentProps, 'children'> {
  errorMessage?: string | undefined;
}

interface LabeledStateTimepickerProps {
  id: string;
  state: ComponentState;

  labeledProps: LabeledProps;
  timePickerProps: TimepickerProps;
}

export const LabeledStateTimepicker = ({ id, labeledProps, timePickerProps, state }: LabeledStateTimepickerProps) => {
  const { errorMessage, stateProperties: labeledStateProperties } = labeledProps;

  const myStateProperties: LabeledComponentProperties = {
    error: {
      message: errorMessage,
      color: 'text-error',
    },
    default: {},
    ...labeledStateProperties,
  };

  const labeledComponentProps = {
    id,
    state,
    stateProperties: myStateProperties,
    ...labeledProps,
  };

  return (
    <LabeledComponent {...labeledComponentProps}>
      <Timepicker {...timePickerProps} />
    </LabeledComponent>
  );
};
